import { h } from 'preact';
import type { Preview } from '../types';
import { VertexLink } from './shared/VertexLink';

export interface VertexPreviewCardProps {
  url: string;
  preview?: Preview | null;
  onClick?: (e: Event) => void;
}

export function VertexPreviewCard({ url, preview, onClick }: VertexPreviewCardProps) {
  if (preview) {
    return (
      <div class="vertex-preview-inline" onClick={onClick}>
        {preview.image && (
          <img
            src={preview.image}
            alt=""
            class="vertex-preview-thumb"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
        )}
        <div class="vertex-preview-inline-text">
          <VertexLink href={url} class="vertex-url" title={url}>
            {preview.title || url}
          </VertexLink>
          {preview.description && (
            <p class="vertex-preview-inline-desc">{preview.description}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <VertexLink href={url} class="vertex-url" title={url}>
      {url}
    </VertexLink>
  );
}
